import FragmentPage from '../core/FragmentPage';

export default class ActividadesPage extends FragmentPage {
  constructor(meta) {
    super('actividades', meta);
  }
}
